import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/Bits";
import ProcurementTable from "@/components/ProcurementTable";

export default function Procurement() {
  return (
    <div className="space-y-10" data-testid="procurement-page">
      <PageHeader
        overline="Operations"
        title="Procurement"
        subtitle="Every ordered item across the studio — status, tracking, delivery and install."
        actions={
          <Link
            data-testid="procurement-add-product-btn"
            to="/products/new"
            className="inline-flex items-center gap-2 rounded-sm bg-lime px-4 py-2.5 text-sm font-medium text-ink transition-colors hover:bg-lime-dark"
          >
            <Plus className="h-4 w-4" strokeWidth={1.5} /> Add Product
          </Link>
        }
      />
      <ProcurementTable />
    </div>
  );
}
